export const sampleAccountsData = [
    {
        "id": 9,
        "userId": 7,
        "availableBalance": 4216.44,
        "currentBalance": 4216.44,
        "institutionType": "depository",
        "officialName": "Select Checking",
        "plaidItemId": "m3kZERKQL9hr9o7kAMxAhykNpPMMwmhMj9b3Q",
        "accountSubType": "checking",
        "accountSubGroup": "First",
        "institutionName": "SunTrust",
        "userEnabled": true,
        "accountRank": "First",
        "publicToken": "public_token_unavailable",
        "plaidAccountId": "m3kZERKQL9hr9o7kAMxAhyZp3NbY36IMjLABm",
        "accountState": "OKAY"
    },
    {
        "id": 288,
        "userId": 7,
        "availableBalance": 306.93,
        "currentBalance": 306.93,
        "institutionType": "depository",
        "officialName": "Regular Savings",
        "plaidItemId": "j58o61LPpVUedvL5Eo34uzeZ09LrZJFRnBa56",
        "accountSubType": "savings",
        "accountSubGroup": "First",
        "institutionName": "Bank of America",
        "userEnabled": true,
        "accountRank": "first",
        "publicToken": "public_token_unavailable",
        "plaidAccountId": "KoDmBw6zNasVM9y1KAeJhAqAn97Ye8iQkM5v0",
        "accountState": "OKAY"
    },
    {
        "id": 289,
        "userId": 7,
        "availableBalance": 718.98,
        "currentBalance": 718.98,
        "institutionType": "depository",
        "officialName": "Adv Plus Banking",
        "plaidItemId": "j58o61LPpVUedvL5Eo34uzeZ09LrZJFRnBa56",
        "accountSubType": "checking",
        "accountSubGroup": "First",
        "institutionName": "Bank of America",
        "userEnabled": true,
        "accountRank": "first",
        "publicToken": "public_token_unavailable",
        "plaidAccountId": "3VgqJe9pw8sZa6J9jnmvt1p1QNLPJ3sK86J0M",
        "accountState": "OKAY"
    },
    {
        "id": 290,
        "userId": 7,
        "availableBalance": 502.45,
        "currentBalance": 554.49,
        "institutionType": "depository",
        "officialName": "Adv Plus Banking",
        "plaidItemId": "j58o61LPpVUedvL5Eo34uzeZ09LrZJFRnBa56",
        "accountSubType": "checking",
        "accountSubGroup": "First",
        "institutionName": "Bank of America",
        "userEnabled": true,
        "accountRank": "Second",
        "publicToken": "public_token_unavailable",
        "plaidAccountId": "ykm6rxAJp9FZ8X1VAnN7tq6q3rbvwJiO6E7ok",
        "accountState": "OKAY"
    },
    {
        "id": 291,
        "userId": 7,
        "availableBalance": 1750.0,
        "currentBalance": 1750.0,
        "institutionType": "depository",
        "officialName": "Adv Plus Banking",
        "plaidItemId": "j58o61LPpVUedvL5Eo34uzeZ09LrZJFRnBa56",
        "accountSubType": "checking",
        "accountSubGroup": "First",
        "institutionName": "Bank of America",
        "userEnabled": true,
        "accountRank": "Third",
        "publicToken": "public_token_unavailable",
        "plaidAccountId": "Z59RZjbza7Ux5Eo3RdMDIBkbRdj7k8HR1j5MM",
        "accountState": "OKAY"
    },
    {
        "id": 292,
        "userId": 7,
        "availableBalance": 12652.14,
        "currentBalance": 347.86,
        "institutionType": "credit",
        "officialName": "Bank of America Cash Rewards Visa Signature",
        "plaidItemId": "j58o61LPpVUedvL5Eo34uzeZ09LrZJFRnBa56",
        "accountSubType": "credit card",
        "accountSubGroup": "First",
        "institutionName": "Bank of America",
        "userEnabled": true,
        "accountRank": "first",
        "publicToken": "public_token_unavailable",
        "plaidAccountId": "kXrbLPDqpnT3vN0JXbyEiPzPYMyQV6fRgLdDz",
        "accountState": "OKAY"
    },
    {
        "id": 304,
        "userId": 7,
        "availableBalance": 4770.67,
        "currentBalance": 1229.33,
        "institutionType": "credit",
        "officialName": "My Best Buy® Visa® Card",
        "plaidItemId": "drZ4NzEVRKsv9g4qPVPpf3oxzPEbnwib9Ea8d",
        "accountSubType": "credit card",
        "accountSubGroup": "First",
        "institutionName": "BestBuy.com - Credit Card",
        "userEnabled": true,
        "accountRank": "Second",
        "publicToken": "public_token_unavailable",
        "plaidAccountId": "J9EAoDqxmeU9pBN1ojoZimk749a0MDHbdeRND",
        "accountState": "OKAY"
    },
    {
        "id": 305,
        "userId": 7,
        "availableBalance": 0.0,
        "currentBalance": 0.0,
        "institutionType": "credit",
        "officialName": "My Best Buy® Credit Card",
        "plaidItemId": "drZ4NzEVRKsv9g4qPVPpf3oxzPEbnwib9Ea8d",
        "accountSubType": "credit card",
        "accountSubGroup": "First",
        "institutionName": "BestBuy.com - Credit Card",
        "userEnabled": false,
        "accountRank": "first",
        "publicToken": "public_token_unavailable",
        "plaidAccountId": "xpqBzQjv1YSv9bQejdj0fBOMev70NEFMX98PX",
        "accountState": "OKAY"
    },
    {
        "id": 312,
        "userId": 7,
        "availableBalance": 0.0,
        "currentBalance": 0.0,
        "institutionType": "Unknown Inst Type",
        "officialName": "Unknown Official Name",
        "plaidItemId": "qzYOP93vmKsK7L96L7BAi9rzyPX1aeCJaO6xQ",
        "accountSubType": "Unknown Sub Type",
        "accountSubGroup": "First",
        "institutionName": "Amazon.com Store Card",
        "userEnabled": true,
        "accountRank": "first",
        "publicToken": "public-development-8f8035c7-e922-4502-80bf-0796c9f75fe7",
        "plaidAccountId": "ozV5Damv3qsg7N3MN7zbT1QBEOJ5gohBqDNaQ",
        "accountState": "ITEM_ERROR"
    },
    {
        "id": 324,
        "userId": 7,
        "availableBalance": 9971.0,
        "currentBalance": 28.94,
        "institutionType": "credit",
        "officialName": "Blue Cash Everyday®",
        "plaidItemId": "BXbv4365jmTEP98rzkx3UEoyJMrD7Vs9Ykpgw",
        "accountSubType": "credit card",
        "accountSubGroup": "First",
        "institutionName": "American Express",
        "userEnabled": true,
        "accountRank": "first",
        "publicToken": "public_token_unavailable",
        "plaidAccountId": "5XAw1JjKLYTx6ELaoYjDIyAkyaMyrZuBXMbnw",
        "accountState": "OKAY"
    }
];